<template>
    <HeaderView />

    <div class="container-fluid">

        <BannerView v-if="showBanner" />

        <div class="container mt-5">

            <div class="row">
                <div class="mission-container">
                    <p class="caption">Beveiliging</p>
                    <p>
                        Hoe LeefGoed omgaat met de beveiliging van digitale diensten en persoonsgegevens.
                    </p>
                    <p>
                        <i>LeefGoed - Uw Meest Fictieve Woningcorporatie.</i>
                    </p>
                </div>
            </div>
        </div>

        <div class="header-image image-6"></div>

        <div class="container mt-5">
            <div class="row">
                <p>LeefGoed beheert persoonsgegevens van huurders, woningzoekenden en andere betrokkenen.
                    Wij gaan zorgvuldig met die gegevens om en treffen passende technische en organisatorische
                    maatregelen om ze te beschermen. Hieronder leest u meer over onze aanpak.</p>
                <div class="news-container">
                    <h2>Beveiliging van Mijn LeefGoed</h2>
                    <p>Via het huurdersportaal Mijn LeefGoed kunnen huurders hun huurovereenkomst inzien,
                        reparatieverzoeken indienen en betalingen regelen. Toegang tot dit portaal is
                        beveiligd met een persoonlijk wachtwoord en, waar mogelijk, tweefactorauthenticatie.
                        Wij raden huurders aan een sterk, uniek wachtwoord te gebruiken en dit regelmatig
                        te vernieuwen.</p>
                    <h2>Onze Beveiligingsmaatregelen</h2>
                    <ul>
                        <li><strong>Versleutelde verbindingen:</strong> Alle communicatie via onze website
                            en portalen verloopt via een beveiligde HTTPS-verbinding, zodat gegevens
                            niet kunnen worden onderschept.</li>
                        <li><strong>Toegangsbeveiliging:</strong> Medewerkers hebben alleen toegang tot
                            systemen en gegevens die noodzakelijk zijn voor hun werkzaamheden. Toegang
                            wordt strikt beheerd en regelmatig gecontroleerd.</li>
                        <li><strong>Beveiligde opslag:</strong> Persoonsgegevens worden opgeslagen in
                            systemen met passende technische beveiliging. Wij werken uitsluitend samen
                            met leveranciers die voldoen aan onze beveiligingseisen.</li>
                        <li><strong>Regelmatige audits:</strong> Wij laten onze informatiebeveiliging
                            periodiek toetsen door interne en externe auditors om zwakke plekken tijdig
                            te signaleren en op te lossen.</li>
                        <li><strong>Meldplicht datalekken:</strong> Wij voldoen aan de wettelijke
                            meldplicht voor datalekken. Bij een incident informeren wij betrokkenen
                            en de Autoriteit Persoonsgegevens conform de geldende regelgeving.</li>
                    </ul>
                    <h2>Bewustwording en organisatie</h2>
                    <p>Goede beveiliging begint bij mensen. Onze medewerkers worden regelmatig getraind
                        in veilig werken met persoonsgegevens en digitale systemen. Wij hanteren een
                        duidelijk beleid voor het omgaan met vertrouwelijke informatie en stimuleren
                        een cultuur van alertheid en verantwoordelijkheid.</p>
                    <h2>Vragen of zorgen?</h2>
                    <p>Heeft u vragen over de beveiliging van uw gegevens bij LeefGoed, of vermoedt u
                        een datalek? Neem dan contact op met onze Functionaris Gegevensbescherming via
                        <strong>privacy@leefgoed.nl</strong>. Wij reageren zo snel mogelijk.</p>
                </div>
                <p>
                    LeefGoed staat voor zorgvuldig en transparant beheer van uw gegevens. Uw vertrouwen
                    is de basis van onze dienstverlening.
                </p>
            </div>
        </div>

        <!-- <div class="header-image image-4" style="margin-top:3rem;"></div> -->
    </div>

    <FooterView />
</template>

<script>
import HeaderView from '@/components/HeaderView.vue';
import BannerView from '@/components/BannerView.vue';
import FooterView from '@/components/FooterView.vue';

export default {
    name: 'InfoBeveiliging',
    components: {
        HeaderView, BannerView, FooterView
    }
};
</script>

<style scoped>
.container-fluid {
    margin-bottom: 3em;
}

.mission-container {
    box-sizing: border-box;
    max-width: 73.125rem;
    padding-bottom: 1.3125rem;
    background: white;
}

.fictional-client-mission {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 3.75rem;
}

.fictional-client-container {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}

.journey-guide {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding-bottom: 1.75rem;
    margin-left: 2.9375rem;
}

.fictional-client-text {
    box-sizing: border-box;
    flex: 0 1 auto;
    margin-left: 1.875rem;
}

.journey-guide1 {
    box-sizing: border-box;
    flex: 0 1 auto;
    margin-left: -1.1875rem;
}

.signature {
    font-size: 15pt;
    display: block;
    margin-top: 2rem;
}

.header-image {
    width: 100%;
    height: 11em;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.image-1 {
    background-image: url(@/assets/carousel_2.jpg);
}

.image-2 {
    background-image: url(@/assets/about-us.jpg);
}

.image-3 {
    background-image: url(@/assets/office-with-logo.jpg);
}

.image-4 {
    background-image: url(@/assets/about-us-3.jpg);
}

.image-6 {
    background-image: url(@/assets/about-us-6.jpg);
}

.news-container {
    background: #f6f9ff;
    padding: 2.5em;
    margin-top: 2em;
    margin-bottom: 2em;
}

.news-container p {
    text-align: justify;
}

.news-container h2 {
    color: #444;
    font-weight: normal;
    margin-bottom: 0.5em;
    font-size: 1.9rem;
}
</style>